module.exports = __webpack_public_path__ + "media/components/patient-page/gene-details-modal/spinner-dd6b7b0bf5c3af22499abc0a9ee1e1b2.gif";